module.exports = __webpack_public_path__ + "04809389939cce9a627f76f0b8c4331c.svg";